import { atom } from "recoil";

// 알림 목록 상태
export const notificationListState = atom({
  key: "notificationListState",
  default: {
    list: [],
    total: 0,
    page: 1,
    pageSize: 20,
    loading: false,
    error: null,
  },
});

// 읽지 않은 알림 개수 상태
export const unreadNotificationCountState = atom({
  key: "unreadNotificationCountState",
  default: 0,
});

// 알림 모달 열림 상태
export const notificationModalOpenState = atom({
  key: "notificationModalOpenState",
  default: false,
});
